import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MembersOnlyWarningModalState } from './types';

const INITIAL_STATE: MembersOnlyWarningModalState = {
  visible: false,
};

const membersOnlyWarningModalSlice = createSlice({
  name: 'membersOnlyWarningModal',
  initialState: INITIAL_STATE,
  reducers: {
    setMembersOnlyWarningModalState: (
      state,
      { payload }: PayloadAction<Omit<MembersOnlyWarningModalState, 'visible'> | null>,
    ) => {
      return {
        ...state,
        ...(payload || undefined),
        visible: !!payload,
      };
    },
  },
});

export default membersOnlyWarningModalSlice;
